import { Injectable, ViewContainerRef } from '@angular/core';
import { Modal, BSModalContext } from 'ngx-modialog/plugins/bootstrap';
import { UploadModalComponent } from './upload-modal.component';
import { overlayConfigFactory } from 'ngx-modialog';

@Injectable()
export class UploadModalService {
    constructor(public modal: Modal) {}

    openDialog(arrObjImgLIST: Object[], nIndex: number, objPostData: Object, viewContainer:ViewContainerRef) {
    	(this.modal.overlay as any).defaultViewContainer = viewContainer;
        return this.modal.open(UploadModalComponent, overlayConfigFactory(
        	{ arrObjImgLIST: arrObjImgLIST, nIndex: nIndex, objPostData: objPostData}, BSModalContext));
    };
}



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/upload-modal/upload-modal.service.ts